import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {VoucherTemplateService} from "../../services/voucherTemplate.service";
import {VoucherTemplate} from "../../models/voucherTemplate";
import {first} from "rxjs/operators";
import {AlertService} from "../../services";

@Component({
    selector: 'add-voucher-dialog',
    templateUrl: './addVoucherDialog.component.html',
    styleUrls: ['./addVoucherDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AddVoucherDialogComponent {
    action: string;
    customer: User;
    numberForm: FormGroup;
    dialogTitle: string;
    vouchers: VoucherTemplate[];
    loadingVouchers = false;
    firstTimeVoucher = false;

    constructor(
        public matDialogRef: MatDialogRef<AddVoucherDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        private voucherService: VoucherTemplateService,
        private alertService: AlertService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.firstTimeVoucher = _data.firstTimeVoucher;

        this.loadingVouchers = true;

        this.voucherService.getAll().pipe(first())
            .subscribe((vouchers: VoucherTemplate[]) => {
                if (this.firstTimeVoucher) {
                    this.vouchers = [];
                    for (let i = 0; i < vouchers.length; i++) {
                        if (!vouchers[i].forOpenDay) {
                            continue;
                        }

                        this.vouchers.push(vouchers[i]);
                    }
                } else {
                    this.vouchers = [];
                    for (let i = 0; i < vouchers.length; i++) {
                        if (vouchers[i].forOpenDay) {
                            continue;
                        }

                        this.vouchers.push(vouchers[i]);
                    }
                }
                this.loadingVouchers = false;
            }, error => {
                this.alertService.error(error);
                this.loadingVouchers = false;
            });

        let expirationDate = null;

        if (this.firstTimeVoucher) {
            expirationDate = new Date();
        } else {
            expirationDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
        }

        this.numberForm = this.createForm(expirationDate);
    }

    createForm(expirationDate: Date): FormGroup {
        return this._formBuilder.group({
            expirationDate: [expirationDate, Validators.required],
            quantity: [1, Validators.required],
            voucher: ['', Validators.required],
        });
    }

    onDateChange(date: any) {
        var d = date.value;
        var month = (d.getMonth()+1).toString();
        var day = d.getDate().toString();
        if (month.length<2) {
            month = '0' + month;
        }
        if (day.length<2) {
            day = '0' + day;
        }
        var datestring = d.getFullYear() + "-" + month  + '-'  + day;
        this.numberForm.controls['expirationDate'].setValue(datestring);
    }
}
